export const APP_LAYOUT = {
  mainScrollClass: "min-h-0 flex-1 overflow-y-auto overscroll-y-contain",
  // Vertical padding is applied inline by MainAppShell (measured header/nav/plate offsets).
  contentClass: "mx-auto w-full max-w-xl px-4",
  messageTextClass: "text-base leading-relaxed whitespace-pre-wrap break-words",
} as const;
